import script from "./ShopVouchersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShopVouchersPage.vue?vue&type=script&setup=true&lang=ts"

import "./ShopVouchersPage.vue?vue&type=style&index=0&id=690463c2&scoped=true&lang=css"
import "./ShopVouchersPage.vue?vue&type=style&index=1&id=690463c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-690463c2"]])

export default __exports__